import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { CompanyDropdown, CompanyDropdownActionType } from "../../actionTypes/master/companyDropdownActionTypes";

export const getCompanyListDropdown = (payload: IDropdownListSearch): CompanyDropdownActionType => ({
  type: CompanyDropdown.GET_COMPANY_DROPDOWN_LIST,
  payload,
});

export const setCompanyListDropdown = (payload: Array<IDropdownItem>): CompanyDropdownActionType => ({
  type: CompanyDropdown.SET_COMPANY_DROPDOWN_LIST,
  payload,
});
